import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

interface QuickLinkTrayPropsType {
    variant: DefaultComponentVariantType | null;
}

const setQuickLinkTrayWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            margin: 0 8px;
            ::-webkit-scrollbar{
                height: 6px;
                background: ${theme.star.quickLinkTray.bgColor};
            }
            ::-webkit-scrollbar-thumb:horizontal{
                background: ${theme.star.quickLinkTray.bgColor};
            }
            &:hover::-webkit-scrollbar-thumb:horizontal {
                background: ${theme.star.quickLinkTray.bgColorSecondary};
                border-radius: ${theme.star.radius.circular};
            }
        `;
    }
    return css`
        box-shadow: inset 0 16px 9px -16px ${theme.star.quickLinkTray.bgColorSecondary};
        scroll-snap-type: x mandatory;
        -webkit-overflow-scrolling: touch;
    `;
};

export const QuickLinkTrayWrapper = withConfig(theme => styled('nav', { label: 'QuickLinkTrayWrapper' })<QuickLinkTrayPropsType>`
    ${({ variant }): SerializedStyles => setQuickLinkTrayWrapper(variant, theme)}
    align-items: center;
    background-color: ${theme.star.quickLinkTray.bgColor};
    display: flex;
    flex-flow: row nowrap;
    height: 65px;
    padding: 0 5px;
    position: relative;
    overflow-x: auto;
    overflow-y: hidden;
`);

export const SportName = withConfig(theme => styled('span', { label: 'SportName' })`
    display: block;
    color: ${theme.star.quickLinkTray.txtColor};
    font-size: ${theme.star.fontSize.xSmall};
    font-weight: ${theme.star.fontWeight.bold};
    text-align: center;
    line-height: 1.2;
    margin-top: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 75px;
`);

export const NavSportWrapper = styled('div', { label: 'NavSportWrapper' })<QuickLinkTrayPropsType>`
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    flex: 0 0 80px;
    scroll-snap-align: start;
    cursor: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? 'pointer': 'auto'};
`;

export const LinkWrapper = styled('div', { label: 'LinkWrapper' })<QuickLinkTrayPropsType>`
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    flex: 0 0 80px;
    text-decoration: none;
    scroll-snap-align: start;
    cursor: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? 'pointer': 'auto'};
`;

export const ImageWrapper = styled('div', { label: 'ImageWrapper' })<{ url: string }>`
    margin: 0 auto;
    width: 20px;
    height: 20px;
    background-image: url(${({ url }): string => url});
    background-repeat: no-repeat;
    background-size: 100%;
`;
